import React, { useEffect, useState } from "react";
import "./AllServices.css";
import NavBar from "../HomePage/NavBar/NavBar";
import BannerSection from "../HomePage/BannerSection/BannerSection";
import AllServiceList from "./AllServiceList/AllServiceList";
import axios from "axios";
import Footer from "../HomePage/Footer/Footer";
import Technology from "../HomePage/Technology/Technology";
import IndustriesSection from "../IndustriesWorkWith/Industries";
import Product from "../HomePage/Products/Product";
function AllServices(props) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <BannerSection
        from={"service"}
        fromText={"Your Partner in Software Development" }
        description={"At Intelligent Bodymorphic Dynamics Limited (IBMDL), we offer comprehensive software development solutions tailored to your business needs. From custom software and web development to cloud-based applications, our expert team delivers innovative, efficient, and high-quality solutions that help drive your business forward."}
      />
      <AllServiceList />
      <Technology />
      <IndustriesSection/>
      <Product />
    </div>
  );
}

export default AllServices;
